import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import MultiSelect from "react-widgets/Multiselect";
import SearchAndSelect from "../common/SearchAndSelect";
import { saveFormsySubmission } from "../services/soar";
import { ShareWith } from "./supervisionScripts";

function NewSupervisionModal({ safyUsers, refreshData }) {
  const [isOpen, setIsOpen] = useState(false);
  const [supervisionType, setSupervisionType] = useState("individual");
  const [employee, setEmployee] = useState({});
  const [sharedWith, setSharedWith] = useState([]);
  const user = JSON.parse(localStorage.getItem("safyInfo")).user;
  const navigate = useNavigate();

  const handleClose = () => {
    setIsOpen(false);
    setSupervisionType("individual");
    setEmployee({});
    setSharedWith([]);
    refreshData();
  };

  const handleSave = () => {
    const submission = {
      ContainerId:
        supervisionType === "individual"
          ? "A51B13BE-6B02-EF11-8076-DC98408D5418"
          : "E2DD0183-5809-EF11-8076-0050F21C653C",
      VersionId:
        supervisionType === "individual"
          ? "9BBCDEA7-6C02-EF11-8076-DC98408D5418"
          : "A754A6D2-5809-EF11-8076-0050F21C653C",
      ApplicationId:
        process.env.REACT_APP_ENVIRONMENT === "Production"
          ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
          : "58990f83-8566-4ba8-b4b5-584a64e4cba1",
      PrimaryObjectId:
        supervisionType === "individual"
          ? employee.azureid.toUpperCase()
          : user.azureId.toUpperCase(),
      PrimaryObjectName:
        supervisionType === "individual" ? employee.name : user.displayName,
      PrimaryObjectType: "Supervisee Azure ID",
      SecondaryObjectId:
        supervisionType === "individual"
          ? user.azureId.toUpperCase()
          : employee.azureid.toUpperCase(),
      SecondaryObjectName:
        supervisionType === "individual" ? user.displayName : employee.name,
      SecondaryObjectType: "Supervisor Azure ID",
      TertiaryObjectId: "",
      TertiaryObjectName: "",
      TertiaryObjectType: "",
      Related: [],
      Results: "{}",
      Comments: [],
      Signatures: [],
      Compliancy: "",
      ModifiedById: user.azureId.toUpperCase(),
      ModifiedByName: user.displayName,
    };
    saveFormsySubmission(submission, "Insert").then((response) => {
      if (response.data[0].code === "success") {
        if (sharedWith.length > 0) {
          ShareWith([response.data[0].id], sharedWith).then((resp) => {
            setTimeout(() => {
              navigate(
                `/supervision/${supervisionType}/${response.data[0].id}`
              );
            }, 1000);
          });
        } else {
          navigate(`/supervision/${supervisionType}/${response.data[0].id}`);
        }
      }
    });
  };

  return (
    <div>
      <Modal show={isOpen} onHide={handleClose} animation={false} size="lg">
        <Modal.Header closeButton className="bg-safy-info text-white">
          <Modal.Title>New Supervision</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="h4">Type of Supervision Log</div>
            <div className="mb-4">
              <div
                className={`btn ${
                  supervisionType === "individual"
                    ? "btn-primary"
                    : "btn-secondary"
                } m-2`}
                onClick={() => setSupervisionType("individual")}
              >
                Individual
              </div>
              <div
                className={`btn ${
                  supervisionType === "group" ? "btn-primary" : "btn-secondary"
                } m-2`}
                onClick={() => setSupervisionType("group")}
              >
                Group
              </div>
            </div>
            <SearchAndSelect
              label={`Select a ${
                supervisionType === "individual" ? "Supervisee" : "Supervisor"
              }`}
              options={safyUsers}
              setSelected={(e) => {
                setEmployee(e);
              }}
              searchLabel="Search by Name"
              searchFieldName="name"
            ></SearchAndSelect>
            <div className="h5">Select Users to Share With if Applicable</div>
            <div className="text-danger mb-2">
              *Supervision logs won't be shared until initially signed
            </div>
            <MultiSelect
              name="sharing"
              data={safyUsers}
              dataKey="_id"
              textField="name"
              filter="contains"
              onChange={(e) => {
                const obj = e.map((i) => ({
                  name: i.name,
                  azureId: i.azureid,
                  domain: i._id,
                  sharedById: user.azureId.toUpperCase(),
                  sharedByName: user.displayName,
                  sharedByDomain: user.email,
                  date: new Date().toLocaleDateString(),
                }));
                setSharedWith(obj);
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn btn-danger" onClick={handleClose}>
            Close
          </div>
          <div className="btn btn-success" onClick={handleSave}>
            Create Log
          </div>
        </Modal.Footer>
      </Modal>

      <div
        className="btn btn-primary float-end"
        onClick={() => setIsOpen(true)}
      >
        New Supervision Log
      </div>
    </div>
  );
}

export default NewSupervisionModal;
